<template>
  <v-card class="pa-5 rounded-lg">
    <div class="d-flex justify-space-between align-center">
      <h5 class="mb-0">Minhas Solicitações de Recurso</h5>
      <v-btn color="primary" small @click="createResourceRequest">
        <v-icon>mdi-plus</v-icon>
        Solicitação
      </v-btn>
    </div>
    <v-alert v-if="error" type="error" class="mb-0">
      {{ error }}
    </v-alert>
    <v-data-table
      v-else
      :loading="loading"
      :items="requests"
      :headers="headers"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
      </template>
      <template v-slot:item.Party="{ item }">
        <span v-if="item.Party">{{ item.Party.name }}</span>
        <span v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <i class="text-13">Não vinculado</i>
              </span>
            </template>
            <span>Evento não vinculado</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.code="{ item }">
        <span v-if="item.code" class="font-weight-bold">{{ item.code }}</span>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <i class="text-13">#{{ item.id | shortId(5) }}</i>
            </span>
          </template>
          <span>Código gerádo após a solicitação</span>
        </v-tooltip>
      </template>
      <template v-slot:item.amount="{ item }">
        {{ item.amount | currency(true) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="statuses[item.status].color"
          small
          label
          class="white--text"
        >
          {{ statuses[item.status].text }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn small text :to="`/admin/resource-request/${item.id}`">
          Gerenciar
          <v-icon small right>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { status } from "@/definitions/ResourceRequest.json";
import RESOURCE_REQUEST from "@/services/admin/resourceRequest";
export default {
  name: "MyResourceRequest",
  data() {
    return {
      headers: [
        { text: "Cod.", value: "code" },
        { text: "Evento", value: "Party" },
        { text: "Data", value: "createdAt" },
        { text: "Valor", value: "amount" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", align: "end" },
      ],
      statuses: status,
      requests: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    createResourceRequest() {
      this.$router.push({ name: "admin.resource-request.create" });
    },
    async getRequests() {
      try {
        this.loading = true;
        const response = await RESOURCE_REQUEST.getMy();
        this.requests = response.resourceRequests;
      } catch (error) {
        this.error =
          error.message || "Erro ao buscar suas solicitações de recurso";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("company", ["selectedOrganization"]),
  },
  mounted() {
    this.getRequests();
  },
};
</script>
